import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';

class PrivacyPolicyComponent extends Component {
  <template>
    <div class='layout-content-1 layout-item-3-1 search-pad grid-limit'>
      <div class='layout-body layout-item centered'>
        <h1>Terms and Conditions</h1>
        <p><strong>Last updated January 01, 2024</strong></p>
      </div>
    </div>
  </template>
}

export default RouteTemplate(PrivacyPolicyComponent);
